import localforage from 'localforage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { type BusinessInfo } from '../types';

interface BusinessStore {
    businessInfo: Partial<BusinessInfo>;
    update: (data: Partial<BusinessInfo>) => void;
    reset: VoidFunction;
}

export const useBusinessStore = create(
    persist<BusinessStore>(
        (set, get) => ({
            businessInfo: {},
            update: (data) => {
                const updatedData = { ...get().businessInfo, ...data };
                set({ businessInfo: updatedData });
            },
            reset: () => set({ businessInfo: {} }),
        }),
        {
            name: 'business-info',
            storage: createJSONStorage(() => localforage),
        },
    ),
);
